  /*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  Header,
  Button,
  Modal,
  Table,
  TableHeaderCell,
} from "semantic-ui-react";
import ReadAxios from "../../axiosComponent/read";
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import { translate } from "react-i18next";
import FormikModalAllot from "../modals/interestedModal";
import { isEmpty, random } from "lodash";

function OrderDetails(props) {
  const [getCurrentOrderDetails, setgetCurrentOrderDetails] = useState(
    props.currenOrder
  );

  const [vehicleType, setvehicleType] = useState();

  useEffect(() => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.currenOrder.vendor_order_id}`,
    }).then((res) => setgetCurrentOrderDetails(res.data.order));
    if (props.currenOrder.proposed_vehicle_type) {
      console.log('component is called');
      getVehicleType(props.currenOrder.proposed_vehicle_type);
    }
  }, []);

  const getVehicleType = (id) => {
    console.log('getVehicleType is called', id);
    // let vehicleTypeManager =
    ReadAxios({ url: `vehicleTypeMaster/${id}` })
      .then((res) => {
        console.log(res.data.resultSet[0])
        setvehicleType(res.data.resultSet[0].vehicleType)
      })
    // vehicleTypeManager = isEmpty(vehicleTypeManager)
    //   ? []
    //   : vehicleTypeManager.data.resultSet;
    //   console.log("vehicleTypeManager", vehicleTypeManager);
    // return vehicleTypeManager[0] ? setvehicleType(vehicleTypeManager[0].vehicleType) : {};
  };

  const { t } = props;
  return (
    <Modal
      open={props.OpenModal}
      size="fullscreen"
      centered={false}
      scrolling="true"
      closeIcon
      onClose={props.CloseModal}
    >
      <Modal.Header>
        <Table.Row>
          <Table.HeaderCell className="p-bold-500">
            {t("title") || "Order Detail"}
          </Table.HeaderCell>
          <Table.HeaderCell className="p-bold-500">
            {!props.currenOrder.allotment_status && (
              <FormikModalAllot
                order={props.currenOrder}
                reFetchOrder={props.reFetchOrder}
              />
            )}
          </Table.HeaderCell>
          {/* <React.Fragment style={{ position: "absolute", right: "20px" }}>
            <Table.HeaderCell>
              <Button basic className="primary">
                Allot
              </Button>
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Button basic className="primary">
                Broadcast
              </Button>
            </Table.HeaderCell>
          </React.Fragment> */}
        </Table.Row>
      </Modal.Header>
      {getCurrentOrderDetails ? (
        <Modal.Content>
          <Modal.Description>
            <>
              <div className="pad w3-small w3-white">
                <Grid columns={4} className="ml-2">
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("order_number") || "Order Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {getCurrentOrderDetails.order_no}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("gross_weight") || "Gross Weight"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {getCurrentOrderDetails.gross_weight}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("order_reference_no") || "Order Reference Number"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {getCurrentOrderDetails.order_reference_no}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Header
                        className="p-bold-200 labelName"
                        size="tiny"
                        as="label"
                        color="grey"
                      >
                        {t("proposed_vehicle_type") || "Proposed Vehicle Type"}
                      </Header>
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Header
                        className="p-bold-500 labelName"
                        size="tiny"
                        as="label"
                        color="black"
                      >
                        {vehicleType ? vehicleType : ""}
                        {/* {getVehicleType(getCurrentOrderDetails.proposed_vehicle_type)} */}
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  {getCurrentOrderDetails.deliveries ? (
                    getCurrentOrderDetails.deliveries.map((delivery, index) => {
                      return (
                        <Grid.Row>
                          <Table unstackable key="deliveries-table">
                            <Table.Header>
                              <Table.Row>
                                <Table.HeaderCell colSpan="8">
                                  {t("delivery_title") || "Delivery"}
                                </Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              <Table.Row>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("delivery_number") || "Delivery Number"}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    {delivery.delivery_no}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("consignor") || "Consignor"}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    {delivery.consignor.name}
                                  </Header>
                                </Table.Cell>
                              </Table.Row>
                              <Table.Row>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("delivery_reference_number") ||
                                      "Reference Number"}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    {delivery.delivery_reference_no}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("consignee") || "Consignee"}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    {delivery.consignee.name}
                                  </Header>
                                </Table.Cell>
                              </Table.Row>
                              <Table.Row>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("temp_min") || "Temperature Minimum"}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    {delivery.tempMin || "NA"}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-200 labelName"
                                    size="tiny"
                                    as="label"
                                    color="grey"
                                  >
                                    {t("temp_max") || "Temperature Maximum"}
                                  </Header>
                                </Table.Cell>
                                <Table.Cell colSpan="2">
                                  <Header
                                    className="p-bold-500 labelName"
                                    size="tiny"
                                    as="label"
                                    color="black"
                                  >
                                    {delivery.tempMax || "NA"}
                                  </Header>
                                </Table.Cell>
                              </Table.Row>
                              {props.movement_type &&
                                props.movement_type === "import" && (
                                  <Table.Row>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {"Container Number" ||
                                          props.t("container_number")}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {delivery.container_no || "NA"}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {"Container Drop Location" ||
                                          props.t("container_drop_location")}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {delivery.container_drop_location ||
                                          "NA"}
                                      </Header>
                                    </Table.Cell>
                                  </Table.Row>
                                )}
                              {props.movement_type &&
                                props.movement_type === "import" && (
                                  <Table.Row>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {"Container Pickup Date" ||
                                          props.t("container_pickup_date")}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {localStorage.getItem('customerNumber') == 1122 ? moment(delivery.container_pickup_date).format("dd-mm-yyyy") || "NA" : delivery.container_pickup_date || "NA"}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {"Container Return Date" ||
                                          props.t("container_return_date")}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {/* {delivery.container_return_date || "NA"} */}
                                        {localStorage.getItem('customerNumber') == 1122 ? moment(delivery.container_return_date).format("dd-mm-yyyy") || "NA" : delivery.container_return_date || "NA"}

                                      </Header>
                                    </Table.Cell>
                                  </Table.Row>
                                )}
                              {props.movement_type &&
                                props.movement_type === "import" && (
                                  <Table.Row>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {"Storage Expiration" ||
                                          props.t("storage_expiration")}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {delivery.storage_expiration_date ||
                                          "NA"}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {"Demurrage Expiration" ||
                                          props.t("demurrage_expiration")}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {delivery.demurrage_expiration_date ||
                                          "NA"}
                                      </Header>
                                    </Table.Cell>
                                  </Table.Row>
                                )}
                              {props.movement_type &&
                                props.movement_type === "import" && (
                                  <Table.Row>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {"ATA" || props.t("ata")}
                                      </Header>
                                    </Table.Cell>
                                    <Table.Cell colSpan="2">
                                      <Header
                                        className="p-bold-500 labelName"
                                        size="tiny"
                                        as="label"
                                        color="black"
                                      >
                                        {delivery.ata_date || "NA"}
                                      </Header>
                                    </Table.Cell>
                                  </Table.Row>
                                )}
                              {delivery.products ? (
                                delivery.products.map((pro, prindex) => {
                                  console.log(pro);
                                  return (
                                    <Table.Row>
                                      <Table.Cell colSpan="8">
                                        <Table>
                                          <Table.Header>
                                            <Table.Row>
                                              <TableHeaderCell colSpan="8">
                                                {t("product_title") ||
                                                  "Product"}
                                              </TableHeaderCell>
                                            </Table.Row>
                                          </Table.Header>
                                          <Table.Body>
                                            <Table.Row>
                                              <Table.Cell>
                                                <Header
                                                  className="p-bold-200 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("product_code") ||
                                                    "Product Code"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="black"
                                                >
                                                  {pro.sku
                                                    ? pro.sku.product_code
                                                    : "NA"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell>
                                                <Header
                                                  className="p-bold-200 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("product_name") ||
                                                    "Product Name"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="black"
                                                >
                                                  {pro.sku
                                                    ? pro.sku.product_name
                                                    : "NA"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell>
                                                <Header
                                                  className="p-bold-200 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="grey"
                                                >
                                                  {t("quantity") || "Quantity"}
                                                </Header>
                                              </Table.Cell>
                                              <Table.Cell colSpan="2">
                                                <Header
                                                  className="p-bold-500 labelName"
                                                  size="tiny"
                                                  as="label"
                                                  color="black"
                                                >
                                                  {pro.quantity || "NP"}
                                                </Header>
                                              </Table.Cell>
                                            </Table.Row>
                                          </Table.Body>
                                        </Table>
                                      </Table.Cell>
                                    </Table.Row>
                                  );
                                })
                              ) : (
                                <LoadingPlaceholder />
                              )}
                            </Table.Body>
                          </Table>
                        </Grid.Row>
                      );
                    })
                  ) : (
                    <LoadingPlaceholder />
                  )}
                </Grid>
              </div>
            </>
          </Modal.Description>
        </Modal.Content>
      ) : (
        <LoadingPlaceholder />
      )}
      <Modal.Actions>
        <center>
          <Button size="mini" color="primary" onClick={props.CloseModal}>
            {" "}
            {t("action_button.close") || "Close"}{" "}
          </Button>
        </center>
      </Modal.Actions>
    </Modal>
  );
}

export default translate("order_details")(OrderDetails);
